<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-default">
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header class="border-0">
              <h3 class="mb-0">Listado de usuarios registrados</h3>
            </b-card-header>

            <el-table class="table-responsive table"
                      header-row-class-name="thead-light"
                      :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
            >
              <el-table-column label="Nombres"
                               min-width="170px"
                               prop="name">
              </el-table-column>
              <el-table-column label="Email"
                               prop="email"
                               min-width="300px">
              </el-table-column>

              <el-table-column label="Telefono"
                               min-width="200px"
                               prop="phone">
              </el-table-column>
              <el-table-column label="Identification"
                               min-width="200px"
                               prop="identification">
              </el-table-column>
              <el-table-column label="Estado" prop="isActive" min-width="150px">
                <template v-slot="{row}">
                  {{ row.isActive|status }}
                </template>
              </el-table-column>
              <el-table-column label="Nuevo registro" prop="isAutoRegister" min-width="150px">
                <template v-slot="{row}">
                  <h4 style="font-size: 1em" :class="{'badge badge-info': row.isAutoRegister}">
                    {{ row.isAutoRegister? 'Si': 'No' }}
                  </h4>
                </template>
              </el-table-column>
              <el-table-column label="Fecha registro" prop="created_at" min-width="200px">
                <template v-slot="{row}">
                  {{ row.created_at|formatDate }}
                </template>
              </el-table-column>
              <el-table-column label="Opciones" min-width="250px">
                <template slot="header" slot-scope="scope">
                  <el-input
                    v-model="search"
                    size="mini"
                    placeholder="Filtro nombre"/>
                </template>
                <template v-slot="{row}">
                  <button class="btn btn-sm btn-outline-primary" @click="view(row._id)">
                    <i class="ni ni-bold-right"></i>
                  </button>
                </template>
              </el-table-column>
            </el-table>

            <b-card-footer class="py-4 d-flex justify-content-end">
              <base-pagination v-model="currentPage" :per-page="20" :total="total"></base-pagination>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui'
import {get} from "@/util/axiosRequest";

export default {
  name: 'page-visits-table',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data: () => ({
    tableData: [
      {
        name: '',
        email: '',
        phone: '',
        identification: '',
        isActive: '',
        created_at: ''
      },
    ],
    search: '',
    currentPage: 1,
    total: 0
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      get('users/find-all', null, true).then(({data}) => {
        this.tableData = data
        this.total = data.length
      })
    },
    view(id) {
      this.$router.push({name: 'user-view', params: {id: id}})
    }
  }
}
</script>
<style>
</style>
